import { FhsAxios, FhsAPI } from "../../services/axios";
import { FhsCancelToken } from "../../services/axios/index_interceptors";
import FhsCookies from "../../services/cookies.js";
import router from "@/router.js";

export default {
  state: {
    registrationStatus: FhsCookies.getItem("registrationStatus") || 40,
    request_on_refresh: false
  },
  actions: {
    userLogin({ commit, getters }, payload) {
      let data = {
        login: payload.userName,
        password: payload.userPassword
      };
      let url = "/auth/login";
      if (payload.byEds) {
        data = {
          auth: payload.sign
        };
        url = "/auth/login-eds";
      }
      return new Promise((resolve, reject) => {
        FhsAxios.post(url, data).then(response => {
          // console.log(response);
          console.log(response);
          if (response.data.status !== 0) {
            let data = response.data.result;
            commit("setUserSystemStatus", data.user.system_status);
            commit("setUserData", data);
            commit("setTokenData", data);
            resolve();
            return;
          } else {
            reject(response);
            return;
          }
          // Устанавливаем информацию о пользователе в локальное хранилище

          // Устанавливаем данные пользователя в глобальной хранилище и возвращаем подтверждение для Промиса
        });
      });
    },
    userLogout({ commit }) {
      return new Promise((resolve, reject) => {
        console.log("try to logour");
        try {
          commit("unsetUserInfo");
          commit("unsetUserData");
          commit("unsetIncomeData");
          commit("unsetUserBalance");
          commit("unsetTotalMoneyInTenge");
          commit("unsetIncomeSinceYearBeginning");
          commit("unsetCompanyName");
          commit("unsetAssetDynamics");
          commit("unsetUserContact");
          commit("setSelectedPortfolio", "all");
          FhsCookies.clear();
          FhsCancelToken.cancel();
          router.push({ name: "auth-login" });
          resolve();
        } catch (e) {
          reject(e);
        }
      });
      // Редиректим и перезагружаем страницу, чтобы полностью очистить глобальное хранилище
    },
    userLoginRefresh({ getters, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        FhsAPI.auth
          .refreshToken()
          .then(res => {
            //console.log(res)
            console.log(`[LK] refresh token configs : ${res}`);
            if (res.data.status) {
              commit("setTokenData", res.data.result);
              // commit("Request_MODULE/_status_code/setStatusCode", false);
              resolve(res);
            } else {
              commit("setTokenData");
              // dispatch("userLogout");
              // if (getters.isLoggedIn) {
              //   commit("Request_MODULE/_status_code/setStatusCode", true);
              // }
              resolve(res);
            }
          })
          .catch(err => {
            //console.log(err)
            reject({
              text: "ОШИБКА В THEN",
              err: err
            });
          });
      });
    },
    checkNCLayer() {
      return FhsAxios.get("https://127.0.0.1:13579/")
        .then(() => {})
        .catch(err => {
          if (err.response.status == 404) {
            return Promise.resolve(err.response);
          } else {
            return Promise.reject(err);
          }
        });
    }
  },
  mutations: {
    setRegistrationStatus: (state, value) => (state.registrationStatus = value)
  },
  getters: {
    registrationStatus: state => state.registrationStatus
  }
};
